import axios from "axios";
import { API_BASE_URL, API_BASE_URL1 } from "../Services/baseApiUrl"
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
    return localStorage.getItem("token");
}

export const getAllDeploymentLocationMaster = async () => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `SecondaryDeployment/GetAllSecondaryDeploymentLocation`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            },
        );
        return response.data;
    } catch (error) {
        throw error
        // console.log(error)
    }
}

export const createDeploymentLocationMaster = async (locationData) => {
    try {
        const response = await axiosInstance.post(API_BASE_URL1 + `SecondaryDeployment/AddNewSecondaryDeploymentLocation`, locationData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

            });


        return response;
    } catch (error) {
        throw error

    }
};

export const updateDeploymentLocationMaster = async (id, requestData) => {
    console.log(requestData, 'requestData Update')
    try {
        const response = await axiosInstance.put(API_BASE_URL1 + `SecondaryCollection/UpdateSecondaryDeploymentLocationDetails`, requestData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                },
            });

        return response;
    } catch (error) {
        throw error

    }
};

export const getLocationById = async (id) => {
    try {
        const response = await axiosInstance.get(API_BASE_URL1 + `deploymentlocation/getById/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                },

            });
        // console.log(response, 'response')
        return response;
    } catch (error) {
        throw error
    }
};